/**
 * Labels canónicos del frontend-superadmin.
 *
 * Fuente única de las etiquetas usuario-facing de los enums del dominio,
 * para no repetir los mismos strings en cada página (espejo del patrón
 * `lib/labels.ts` del portal). Cuando un texto cambie, se cambia aquí.
 */
import type { TipoRecurso } from './api/recursos';

export const RECURSO_TIPO_LABEL: Record<TipoRecurso, string> = {
  llavero: 'Llavero',
  control_remoto: 'Control remoto',
  citofonia: 'Citofonía',
  acceso_app_wifi: 'Acceso app/wifi',
  otro: 'Otro',
};

/** Etiqueta del tipo de recurso, con fallback al valor crudo si no mapea. */
export function etiquetaTipoRecurso(tipo: string): string {
  return RECURSO_TIPO_LABEL[tipo as TipoRecurso] ?? tipo;
}
